import { setIsRouteSelected, setIsSelectingWorkflowRoute } from '@/store/modules/workflowGraphs/actions';
import { useStore } from '@/utils/store';

export const useWorkflowGraphsActions = () => {
	const { dispatch } = useStore();
	return {
		setIsSelectingWorkflowRoute: (value: boolean) => dispatch<boolean, void>(setIsSelectingWorkflowRoute, value),
		setIsRouteSelected: (value: boolean) => dispatch<boolean, void>(setIsRouteSelected, value),
	};
};
